import script from "./UnderstandingBar.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderstandingBar.vue?vue&type=script&setup=true&lang=js"

import "./UnderstandingBar.vue?vue&type=style&index=0&id=552c2f3e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552c2f3e"]])

export default __exports__